// extracted by css-extract-rspack-plugin
export default {"asyncSuggestion":"shared-module__asyncSuggestion__ve8IV","stale":"shared-module__stale__E8ofL"};